import React from 'react';

/**
 * Safe Zones Component
 * Displays safe zones to prevent content from being cut off
 */
const SafeZones = ({ 
    enabled, 
    margin = 5,
    color = '#ef4444',
    opacity = 0.3,
    width,
    height,
    unit = '%'
}) => {
    if (!enabled) return null;

    const marginPx = unit === '%' 
        ? { x: (width * margin) / 100, y: (height * margin) / 100 }
        : { x: margin, y: margin };

    return (
        <svg
            className="absolute inset-0 pointer-events-none z-10"
            width={width}
            height={height}
            style={{ opacity }}
        >
            {/* Safe zone rectangle */}
            <rect
                x={marginPx.x}
                y={marginPx.y}
                width={width - 2 * marginPx.x}
                height={height - 2 * marginPx.y}
                fill="none"
                stroke={color}
                strokeWidth="2"
                strokeDasharray="8 4"
            />
            
            {/* Corner markers */}
            {[
                { x: marginPx.x, y: marginPx.y },
                { x: width - marginPx.x, y: marginPx.y },
                { x: marginPx.x, y: height - marginPx.y },
                { x: width - marginPx.x, y: height - marginPx.y }
            ].map((corner, index) => (
                <g key={`corner-${index}`}>
                    <circle
                        cx={corner.x}
                        cy={corner.y}
                        r="6"
                        fill={color}
                    />
                    <circle
                        cx={corner.x}
                        cy={corner.y}
                        r="3"
                        fill="white"
                    />
                </g>
            ))}

            {/* Labels */}
            <text
                x={width / 2}
                y={marginPx.y - 8}
                fill={color}
                fontSize="11"
                fontWeight="600"
                textAnchor="middle"
            >
                Safe Zone ({margin}{unit})
            </text>
        </svg>
    );
};

export default SafeZones;
